import { noCase } from 'change-case';
export const getAllInfo = (adapter) => {
    return Object.fromEntries(Object.entries(adapter).map(([key, value]) => {
        if (typeof value === 'function') {
            value = value();
        }
        if (typeof value === 'number') {
            value = value.toFixed(2);
        }
        return [noCase(key), value];
    }));
};
export const getAllInfoLines = (adapter, delayed = false) => {
    const info = getAllInfo(adapter);
    if (delayed) {
        for (const key in info) {
            if (key !== 'fpsAveragePrediction' && key !== 'fpsAverageReal') {
                delete info[key];
            }
        }
    }
    return Object.entries(info).map(([key, value]) => {
        return `${key}${delayed ? ' (delayed)' : ''}: ${value}`;
    });
};
